"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPodcast = void 0;
/**
 * Fixes an incomplete XML feed by ensuring it ends with a complete <item> tag
 * and closes with </channel></rss> tags. If no incomplete <item> tags are found,
 * the original XML data is returned unmodified.
 *
 * @param xmlData - The XML data that may be incomplete.
 * @returns The fixed XML data with properly closed tags.
 */
function fixIncompleteFeed(xmlData) {
    // Length of the </item> tag
    const itemTagLength = 7;
    // Find the last complete <item> tag
    const lastItemIndex = xmlData.lastIndexOf("</item>");
    // If no <item> tag is found, return the original data
    if (lastItemIndex === -1) {
        return xmlData;
    }
    // Cut off everything after the last complete <item> tag
    const fixedData = xmlData.substring(0, lastItemIndex + itemTagLength);
    // Close the feed with </channel></rss>
    return `${fixedData}</channel></rss>`;
}
/**
 * Fetches the podcast content from the provided URL.
 *
 * @param url - The URL of the podcast.
 * @param config - Optional configuration object for the fetch request.
 * @returns A promise that resolves to the text content of the podcast response.
 * @throws If the fetch request fails.
 */
function fetchPodcast(url, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = new Headers(config === null || config === void 0 ? void 0 : config.requestHeaders);
        if (config === null || config === void 0 ? void 0 : config.requestSize) {
            headers.set("Range", `bytes=0-${config.requestSize}`);
        }
        const response = yield fetch(url.toString(), { headers, redirect: "follow" });
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        let text = yield response.text();
        if (config === null || config === void 0 ? void 0 : config.requestSize) {
            text = fixIncompleteFeed(text);
        }
        return text;
    });
}
exports.fetchPodcast = fetchPodcast;
